import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles/main.css'
import { App } from './App.tsx'

const params = new URLSearchParams(window.location.search);
const propertyId = params.get("propertyId");
const token = params.get("token");
if (propertyId) sessionStorage.setItem("propertyId", propertyId);
if (token) sessionStorage.setItem("inventoryToken", token);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
